/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListDomainsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListDomainsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListDomainsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListDomainsSecurity$outboundSchema: z.ZodMiniType<
  ListDomainsSecurity$Outbound,
  ListDomainsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listDomainsSecurityToJSON(
  listDomainsSecurity: ListDomainsSecurity,
): string {
  return JSON.stringify(
    ListDomainsSecurity$outboundSchema.parse(listDomainsSecurity),
  );
}

/** @internal */
export type ListDomainsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListDomainsRequest$outboundSchema: z.ZodMiniType<
  ListDomainsRequest$Outbound,
  ListDomainsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function listDomainsRequestToJSON(
  listDomainsRequest: ListDomainsRequest,
): string {
  return JSON.stringify(
    ListDomainsRequest$outboundSchema.parse(listDomainsRequest),
  );
}
